import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

/* eslint-disable no-console */
bootstrapApplication(App, appConfig).catch((err) => console.error(err));
/* eslint-enable no-console */
